import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ProductPage from '../components/ProductPage';
import { thermalCategories, thermalProductBySlug, thermalProductsByCategory, thermalProductPath } from '../data/thermal';

const ThermalProductPage = ({ category, onRequestDemo, onRequestQuote }) => {
  const { slug } = useParams();
  const cat = thermalCategories[category];
  const product = thermalProductBySlug(category, slug);
  if (!product) return <Navigate to={cat.path} replace />;

  const siblings = thermalProductsByCategory(category).filter((p) => p.slug !== product.slug);

  return (
    <ProductPage
      productName={product.name}
      tagline={product.tagline}
      description={product.description}
      metaDescription={product.metaDescription}
      image={product.images[0]}
      images={product.images}
      imageContain
      features={product.features}
      specifications={product.specifications}
      applications={product.applications}
      heroExtra={
        <div className="mb-6 flex flex-wrap items-center gap-2" data-testid="thermal-product-siblings">
          <span className="rounded-full bg-blue-500/20 border border-blue-400/30 px-3 py-1 text-xs font-semibold text-blue-200" data-testid="thermal-product-models">
            Models: {product.models}
          </span>
          <Link
            to={cat.path}
            className="inline-flex items-center gap-1 rounded-full border border-blue-300/40 bg-blue-500/10 px-3 py-1 text-xs font-semibold text-blue-200 hover:bg-blue-500/20 transition-colors"
            data-testid="thermal-product-back-to-hub"
          >
            <ArrowLeft className="w-3 h-3" aria-hidden="true" /> All {cat.shortName}
          </Link>
          {siblings.map((s) => (
            <Link
              key={s.slug}
              to={thermalProductPath(s)}
              className="rounded-full border border-white/15 px-3 py-1 text-xs font-medium text-slate-200 hover:border-blue-300/60 hover:text-white transition-colors"
              data-testid={`thermal-product-sibling-${s.slug}`}
            >
              {s.menuName}
            </Link>
          ))}
        </div>
      }
      onRequestDemo={onRequestDemo}
      onRequestQuote={onRequestQuote}
    />
  );
};

export default ThermalProductPage;
